import ReactECharts from 'echarts-for-react';
import echarts from '../echarts';
import { COST_STRUCTURE } from '../data/mockData';

// 区块6：成本结构柱状图
export default function ChartBarCost() {
  const option = {
    backgroundColor: 'transparent',
    title: {
      text: '成本结构分布',
      left: 'center',
      textStyle: { color: '#fbbf24', fontSize: 20, fontWeight: 'bold' },
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'shadow' },
      formatter: '{b}: {c}%',
      backgroundColor: 'rgba(15, 23, 42, 0.9)',
      borderColor: '#fbbf24',
      textStyle: { color: '#fff' },
    },
    grid: { left: '3%', right: '4%', bottom: '8%', top: '18%', containLabel: true },
    xAxis: {
      type: 'category',
      data: COST_STRUCTURE.categories,
      axisLine: { lineStyle: { color: '#475569' } },
      axisLabel: { color: '#e2e8f0', fontSize: 14 },
    },
    yAxis: {
      type: 'value',
      max: 50,
      axisLine: { lineStyle: { color: '#475569' } },
      axisLabel: { color: '#94a3b8', fontSize: 13, formatter: '{value}%' },
      splitLine: { lineStyle: { color: 'rgba(255,255,255,0.08)' } },
    },
    series: [
      {
        name: '成本占比',
        type: 'bar',
        data: COST_STRUCTURE.data,
        itemStyle: {
          color: (params) => {
            const colors = ['#fbbf24', '#06b6d4', '#f97316', '#22c55e', '#a855f7'];
            return colors[params.dataIndex];
          },
          borderRadius: [8, 8, 0, 0],
        },
        barWidth: '45%',
        label: {
          show: true,
          position: 'top',
          formatter: '{c}%',
          color: '#fff',
          fontSize: 14,
          fontWeight: 'bold',
        },
        animationDuration: 1200,
      },
    ],
  };

  return (
    <ReactECharts
      echarts={echarts}
      option={option}
      style={{ width: '100%', height: '100%', minHeight: 360 }}
      opts={{ renderer: 'svg' }}
    />
  );
}
